import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { makeStateKey } from '@angular/platform-browser';
import { of } from 'rxjs';
import { skip, take, map } from 'rxjs/operators';
import { parseQueryPqrams, removeUrlQueryParam } from 'src/app/util';
import * as i0 from "@angular/core";
import * as i1 from "@nguniversal/express-engine/tokens";
import * as i2 from "@angular/platform-browser";
import * as i3 from "@ngx-translate/core";
import * as i4 from "./logger.service";
import * as i5 from "@angular/common";
export const SITE_CONFIG_KEY = makeStateKey('SITE_CONFIG');
export class ServerConfigService {
    constructor(platformId, request, tState, translate, loggerService, document) {
        this.platformId = platformId;
        this.request = request;
        this.tState = tState;
        this.translate = translate;
        this.loggerService = loggerService;
        this.document = document;
        /** 是否為 SSR 模式 */
        this.isSSRMode = false;
        /** 網站 basehref */
        this.baseHref = '/';
        this.isBrowser = isPlatformBrowser(this.platformId);
        this.isServer = isPlatformServer(this.platformId);
        this.isSSRMode = this.isServer || this.tState.hasKey(SITE_CONFIG_KEY);
        if (!this.isBrowser) {
            this.loggerService.info(`isBrowser: ${this.isBrowser}; isServer: ${this.isServer}; isSSRMode: ${this.isSSRMode}`);
        }
        const baseHref = this.document.head.getElementsByTagName('base')[0].getAttribute('href');
        if (baseHref.endsWith('/')) {
            this.baseHref = baseHref.slice(0, baseHref.length - 1);
        }
        else {
            this.baseHref = baseHref;
        }
        if (this.isBrowser) {
            this.url = location.href.replace('/?', '?').replace(/\/$/g, '');
            this.pathname = removeUrlQueryParam(location.pathname).replace(/\/$/g, '');
            // const queryParam = location.search.slice(1, location.search.length);
            this.queryParams = parseQueryPqrams(this.url);
            this.origin = location.origin;
        }
        else {
            this.url = `${this.request.protocol}://${this.request.get('host')}${this.request.originalUrl}`.replace('/?', '?').replace(/\/$/g, '');
            this.loggerService.info(`url: ${this.url}`);
            this.pathname = removeUrlQueryParam(this.request._parsedUrl.pathname).replace(/\/$/g, '');
            this.loggerService.info(`pathname: ${this.pathname}`);
            // const queryParam = this.request._parsedUrl.query;
            this.queryParams = parseQueryPqrams(this.url);
            this.loggerService.info(`queryParams: `, this.queryParams);
            this.origin = `${this.request.protocol}://${this.request.get('host')}`;
        }
        this.isEditModeUrl = !!this.queryParams['stage'];
        if (!this.isBrowser) {
            this.loggerService.info(`isEditModeUrl: ${this.isEditModeUrl}`);
        }
    }
    getConfig(backStageSubj) {
        if (this.tState.hasKey(SITE_CONFIG_KEY)) {
            // 瀏覽器 SSR 開啟
            this.config = JSON.parse(this.tState.get(SITE_CONFIG_KEY, null));
            window['printAllState'] = this.tState.toJson();
        }
        else if (isPlatformServer(this.platformId)) {
            // NODE SSR 開啟
            const urlSegArr = this.pathname.split('/');
            const lang = urlSegArr[1];
            this.config = { lang };
            this.tState.set(SITE_CONFIG_KEY, JSON.stringify(this.config));
        }
        else {
            // 瀏覽器 CSR 開啟
            const urlSegArr = this.pathname.split('/');
            const lang = urlSegArr[1];
            this.config = { lang };
        }
        if (this.config.lang) {
            // 設定i18n
            // this.translate.setDefaultLang(this.config.lang);
            this.translate.use(this.config.lang);
        }
        if (backStageSubj) {
            // 從後台開的
            backStageSubj.pipe(skip(1)).subscribe(v => {
                this.config.backStagePayload = v;
            });
            return backStageSubj.pipe(take(1), map(backStagePayload => {
                this.config.backStagePayload = backStagePayload;
                return this.config;
            }));
        }
        else {
            // 直接進前台的
            return of(this.config);
        }
    }
    getCurrentUrl() {
        if (this.isServer) {
            return this.url;
        }
        else {
            return location.href;
        }
    }
    getCurrentPathname() {
        if (this.isServer) {
            return this.pathname;
        }
        else {
            return location.pathname;
        }
    }
    getCurrentQueryParams() {
        if (this.isServer) {
            return this.queryParams;
        }
        else {
            const queryParamStr = location.search.slice(1, location.search.length);
            const queryParams = queryParamStr ? parseQueryPqrams(queryParamStr) : {};
            return queryParams;
        }
    }
}
ServerConfigService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ServerConfigService_Factory() { return new ServerConfigService(i0.ɵɵinject(i0.PLATFORM_ID), i0.ɵɵinject(i1.REQUEST, 8), i0.ɵɵinject(i2.TransferState, 8), i0.ɵɵinject(i3.TranslateService), i0.ɵɵinject(i4.LoggerService), i0.ɵɵinject(i5.DOCUMENT)); }, token: ServerConfigService, providedIn: "root" });
